import React from 'react';
import Select from 'react-select';
import { useTheme } from 'styled-components';
import { Theme } from 'styles/theme';
import { Option } from 'types/types';
import SmartLabel, { TSmartLabelProps } from '../labels/SmartLabel';
import { ExpandableHelpHtml } from '../help-boxes/ExpandableHelpHtml';
import { getCustomWizardSelectStyles } from '../epd-compiler-inputs/select-styles';
import useIsReadOnlyMode from '../compiler/hooks/useIsReadOnlyMode';

type TProps = Partial<TSmartLabelProps> & {
  name: string;
  value: any;
  options: any[];
  isMulti?: boolean;
  style?: any;
  onChanged: any;
  placeholder?: string;
  disabled?: boolean;
  isClearable?: boolean;
  error?: string;
  helpText?: string;
} & any;

const WizardSelectControlledComponent: React.FunctionComponent<TProps> = ({
  label,
  options,
  tooltip,
  labelStyle,
  name,
  value,
  onChanged,
  disabled,
  style,
  placeholder,
  required,
  isMulti,
  error,
  isClearable = true,
  helpText,
  ...props
}) => {
  const theme = useTheme() as Theme;
  const customSelectStyles = getCustomWizardSelectStyles(theme);
  const isReadOnly = useIsReadOnlyMode() || disabled;

  return (
    <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
      {label && (
        <SmartLabel
          label={label}
          required={required}
          labelStyle={labelStyle}
          tooltip={tooltip}
          hasValue={isMulti ? value && value.length > 0 : !!value?.value}
          error={error}
        />
      )}
      {helpText && !isReadOnly && (
        <div style={{ marginBottom: 10 }}>
          <ExpandableHelpHtml html={helpText} />
        </div>
      )}
      <Select
        options={options}
        name={name}
        value={value}
        onChange={(e: any) => {
          e !== value && onChanged(name, isMulti ? e?.map((x: Option) => x.value) : e?.value);
        }}
        isClearable={isClearable}
        isMulti={isMulti}
        isDisabled={isReadOnly}
        styles={customSelectStyles}
        {...props}
      />
    </div>
  );
};

export default WizardSelectControlledComponent;
